var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C17.8051 32 19.2821 30.5231 19.2821 28.7179H12.7179C12.7179 30.5231 14.1785 32 16 32ZM25.8462 22.1538V13.9487C25.8462 8.91077 23.1549 4.69333 18.4615 3.57744V2.46154C18.4615 1.09949 17.3621 0 16 0C14.6379 0 13.5385 1.09949 13.5385 2.46154V3.57744C8.82872 4.69333 6.15385 8.89436 6.15385 13.9487V22.1538L2.8718 25.4359V27.0769H29.1282V25.4359L25.8462 22.1538Z",
    fill: "#002466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d91c948284dd469a67abd40eeef93f52.svg";
export { ForwardRef as ReactComponent };